import { render } from "./FullScreenDialog.vue?vue&type=template&id=3c0bf6da&scoped=true"
import script from "./FullScreenDialog.vue?vue&type=script&lang=js"
export * from "./FullScreenDialog.vue?vue&type=script&lang=js"

import "./FullScreenDialog.vue?vue&type=style&index=0&id=3c0bf6da&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0bf6da"]])

export default __exports__